import Ajax from './ajax';
// 登录
export default {
  // 监考老师登录
  POSTlogin1(param = {}) {
    return Ajax.post(`/api/live/v1/teacher/login`, { ...param });
  },
};
